import template from './companies_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class CompaniesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class CompaniesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new CompaniesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'CompaniesHelp',
	dialog_class: CompaniesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/companies_help',
	provider: 'ps'
};
